import React, { useEffect, useState } from 'react';
import ConfirmationDialog from './ConfirmationDialog';
import { Share } from '@capacitor/share';

export const SHOW_FILE_OPEN_ERROR_EVENT = 'SHOW_FILE_OPEN_ERROR';
export const NO_APP_FOUND_ERROR_CODE = 'OS-PLUG-FLVW-0010';

export const dispatchFileOpenError = (filename: string, uri: string) => {
  const event = new CustomEvent(SHOW_FILE_OPEN_ERROR_EVENT, {
    detail: { filename, uri },
  });
  window.dispatchEvent(event);
};

const FileOpenErrorDialog = () => {
  const [open, setOpen] = useState(false);
  const [filename, setFilename] = useState('');
  const [fileUri, setFileUri] = useState('');

  useEffect(() => {
    const handler = (e: CustomEvent) => {
      setFilename(e.detail?.filename || 'the file');
      setFileUri(e.detail?.uri || '');
      setOpen(true);
    };
    window.addEventListener(SHOW_FILE_OPEN_ERROR_EVENT as any, handler);
    return () =>
      window.removeEventListener(SHOW_FILE_OPEN_ERROR_EVENT as any, handler);
  }, []);

  const handleSave = async () => {
    if (fileUri) {
      try {
        await Share.share({
          title: 'Save File',
          text: `Save ${filename}`,
          url: fileUri,
          dialogTitle: 'Save File',
        });
      } catch (error) {
        console.error('Error sharing file:', error);
      }
    }
    setOpen(false);
  };

  return (
    <ConfirmationDialog
      open={open}
      title='Cannot Open File'
      contentText={`No application found on your device to open "${filename}". Would you like to save it manually?`}
      onClose={() => setOpen(false)}
      onConfirm={handleSave}
      confirmButtonText='Save File'
      cancelButtonText='OK'
    />
  );
};

export default FileOpenErrorDialog;
